










































































































































































































































































































































































































































































































































































































































import { CreateMode, ConsumerType, CardType, ApplyArea, ServiceType, TravelReasonType, RoleType, BusinessType, PriceType, YesOrNo, categoryMap, DutyCode } from "../../model/Base";
import UserService from "../../service/UserService";
import { Result, RoleInfoEntity, CardInfoEntity, ContactInfoEntity, RoleInfo, FlowNodeEntity } from "../../model/system";
import dataShare from "./dataShare";
import flightService from "@/service/flightService";
import hotelService from "@/service/hotelService";
import trainService from "@/service/trainService";

import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import {
  ActionSheet,
  Circle,
  Collapse,
  CollapseItem,
  Switch,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Popup,
  Picker,
  Card,
  Field,
  Overlay,
  Loading,
  Dialog,
  Progress,
  NoticeBar,
  TreeSelect,
  Icon,
  Uploader
} from "vant";
import SystemService from "@/service/UserService";
import * as _ from "lodash";
import { FlightProductEntity, FlightGoodsEntity, PolicyInfoEntity } from "@/model/FlightPolicy";
import { dateDiff, DurationTime } from "@/utils/utils";
import moment from "moment";
import roleUtils from "@/utils/roleUtils";
import btripServcice from "@/service/btripServcice";
import { BtripTextEntity, ProjectEntity, TripRoleEntity, TripRuleEntity } from "@/model/Btrip";
import { OrderStatus } from "@/model/Base";
import insurancePolicyService from "@/service/insurancePolicyService";
import chargePolicyService from "@/service/chargePolicyService";
import HeaderBar from "@/components/headerBar.vue";
import accountStatus from "./modules/trainAccountStatus.vue";
// import { result } from "lodash";
import { removeKeepalive } from "../modules/keepUtils";
import WatchOrder from "./modules/watchOrder.vue";
import adapterService from "@/service/adapterService";
import { md5 } from "@/utils/md5";
import passengerConfirm from "./modules/passengerConfirm.vue";
// import ticketReminder from "./modules/ticketReminder.vue";
import uploadfile from './modules/uploadfile.vue'
import axios from "axios";
const activePropCode = "selectedRoleID";

const lightCat = "S00008550568,S00000467354,S00008447831,S00010947322";
@Component({
  components: {
    HeaderBar,
    // flightOrder,
    // hotelOrder,
    // trainOrder,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Switch.name]: Switch,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Field.name]: Field,
    [Progress.name]: Progress,
    [Circle.name]: Circle,
    [NoticeBar.name]: NoticeBar,
    [TreeSelect.name]: TreeSelect,
    [ActionSheet.name]: ActionSheet,
    [Uploader.name]: Uploader,
    "account-status": accountStatus,
    "watch-order": WatchOrder,
    passengerConfirm,
    uploadfile
  },
  filters: {
    visualRoleName(role: any) {
      let cards = role.Cards || [];
      let card = _.find(cards, (o: any) => o.isActive) || {};
      if (card.CardType == 1298 || card.CardType == 1299 || card.CardType == 1141 || card.CardType == 1139 || card.CardType == 1297) {
        if (card.EnglishFirstName && card.EnglishLastName) {
          return `${card.EnglishFirstName}/${card.EnglishLastName}`;
        } else {
          return `${role.FirstName}/${role.LastName}`;
        }
      } else {
        return card.RoleName || role.RoleName;
      }
    },
  },
  methods: { dateDiff },
})
// 继承类,声明默认值时使用 = 代替 :
export default class extends Vue {
  LevelNodeID = "";
  gradCurrent = "999";
  personCurrent = "999";
  showSubOrder = false;
  // 弹窗默认关闭
  show = false;
  get isShowApprover() {
    return this.FlowInfoData && this.FlowInfoData.Nodes;
  }
  isShowApprovelPerson = false;
  infoIcon = require("../../../static/img/info.png");

  get DepartDate() {
    return this.$route.query.DepartDate;
  }
  get ArriveDate() {
    return this.$route.query.ArriveDate;
  }
  get approvalCode(){
    return this.$route.query.approvalCode || '';
  }
  //data

  dataShare = dataShare;
  RoleData: RoleInfoEntity[] = [];
  consumers: RoleInfoEntity[] = [];
  selectedInsurances = [];
  model = {
    // ApprovalRule: "1541,1545,1547,1540,1580,1546,1584",
    CreateMode: CreateMode.APP,
    ProductID: "",
    VoyageType: "",
    BookingType: "",
    ApplyArea: ApplyArea.Internal,
    ChooseSeats: "",
    OuterUserAct: "",
    AccountID: "",
    OuterUserPwd: "",
    ServiceType: ServiceType.FlightService,
    CenterID: "",
    IntentID: "",
    IntentName: "",
    ProjectCode: "",
    ContactName: "",
    ContactPhone: "",
    ContactEmail: "",
    ContactEmailNotify: true,
    TicketDelivery: 1450,
    Remark: "",
    chooseApprover: [],
    Contrarys: [] as any[],
    Consumers: [],
    MailingAddress: { AddressID: "", Recipient: "", Address: "", Sex: "", ContactPhone: "", EmsCode: "" },
    Extras: [
      // { ServiceType: 1466, ThrowID: "" },
      // { ServiceType: 1410, ThrowID: "" },
    ] as { ServiceType: number, ThrowID:string,ProductIds?:string[],isBundle?:boolean }[],
    ExtraInfos: [] as any[],
    TrainSeatNo: "",
    seat_type: "",
    ShoppingID: "",
    ClientUniqueID: "",
    ReturnOrderInfo: true,
    showHint: false,
  };
  Selected = [];
  Products: FlightProductEntity[] = [];
  Goods: FlightGoodsEntity = {};
  activeNames = ["1"];
  isMsg = true;
  isEmail = false;
  isNeed = false;
  Hotel = ServiceType.HotelService;
  list = [this.$root.$t("mall_order_yi") as string, this.$root.$t("mall_order_er") as string, this.$root.$t("mall_order_san") as string];
  overlayShow = false;
  showDetail = false;
  roomNum = 1;
  get roomCapacity() {
    let capcity = parseInt(this.extractExtra("Hotel.Product.Capcity", this.policys));

    return isNaN(capcity) ? 2 : capcity;
  }
  showSelectRoomNum = false;
  isShowRule = false;
  showSeatNo = false;
  // get columns() {
  //     const index = (this as any).activeNodeIndex;
  //     return (this as any).FlowInfoData?.Nodes?.[index]?.Roles || [];
  //   }
  get LevelCode() {
    return this.$route.query.seatType;
  }
  get seatList() {
    let guodao: any = {
      select: "过道",
      currentFlag: false,
    };
    let list = [
      {
        select: "A",
        currentFlag: false,
      },
      {
        select: "B",
        currentFlag: false,
      },
      {
        select: "C",
        currentFlag: false,
      },
      {
        select: "D",
        currentFlag: false,
      },
      {
        select: "F",
        currentFlag: false,
      },
    ];
    if (this.LevelCode == "edz") {
      list.splice(3, 0, guodao);
    }
    if (this.LevelCode == "ydz") {
      _.remove(list, (n: any) => n.select == "B");
      list.splice(2, 0, guodao);
    }
    if (this.LevelCode == "swz") {
      _.remove(list, (n: any) => n.select == "B" || n.select == "D");
      list.splice(2, 0, guodao);
    }
    let newlist = [{ data: list }];
    if (this.Selected.length > 1) {
      newlist.push({ data: list });
    }
    return newlist;
  }
  visualCardName(card: any) {
    if (card && card.CardType) {
      const CardTypes = roleUtils.BuildCardTypes((key: string) => this.$root.$t(key) as string);
      return CardTypes.filter((o: any) => o.value == card.CardType)[0].text;
    }
    return "--";
  }
  seatLists: any = [];
  selectSeatNo(inde?: any, index?: any) {
    if (this.seatLists[inde].data[index].currentFlag) {
      this.seatLists[inde].data[index].currentFlag = false;
    } else {
      this.seatLists[inde].data[index].currentFlag = true;
    }
    let num = 0;
    for (var m = 0; m < this.seatLists.length; m++) {
      for (var i = 0; i < this.seatLists[m].data.length; i++) {
        if (this.seatLists[m].data[i].currentFlag) {
          num++;
        }
      }
    }
    if (num > this.Selected.length) {
      this.seatLists[inde].data[index].currentFlag = false;
      return this.$toast.fail(this.$root.$t("share.fail.SeatNumbers"));
    }
  }
  get isShowReject() {
    return this.profile.UserID == "S00010745209" || this.profile.UserAct == "预览";
  }
  get isShowBind12306() {
    return this.ServiceCode == "train";
  }
  @Prop()
  ServiceType!: number;

  get ServiceCode(): string {
    return categoryMap[this.ServiceType].CategoryCode.replace("Service", "").toLowerCase();
  }

  get demandContent(): string {
    return this.dataShare.demandContent;
  }
  get GoodsCount() {
    if (this.ServiceType == ServiceType.HotelService) {
      let days = 1;
      if (this.Products && this.Products[0]) {
        let product = this.Products[0];

        let Arrival = moment(product.ConsumerDate);
        let Depart = moment(product.FinishedDate);
        days = Depart.diff(Arrival, "days");
      }
      return this.roomNum * days;
    } else {
      return this.consumers.length;
    }
  }

  // get GoodsCount() {
  //   if (this.ServiceType == ServiceType.HotelService) {
  //     let days = 1;
  //     if (this.Products && this.Products[0]) {
  //       let product = this.Products[0];

  //       let Arrival = moment(product.ConsumerDate);
  //       let Depart = moment(product.FinishedDate);
  //       days = Depart.diff(Arrival, "days");
  //     }
  //     return this.roomNum * days;
  //   } else {
  //     return this.consumers.length;
  //   }
  // }
  get ExtraGoodsCount() {
    let __self = this;
    if (!__self.policys) {
      return 0;
    }
    let count = 0;
    let policys = __self.policys as any;
    for (var i = 0; i < policys.length; i++) {
      for (var m = 0; m < policys[i].Products.length; m++) {
        var product = policys[i].Products[m];
        if (product.Products && product.Products.length > 0) {
          count += product.Products.length;
        } else {
          count += 1;
        }
      }
    }
    return this.GoodsCount * count;
  }
  get roomNumber() {
    return this.$route.query.roomNumber;
  }
  get AccountID() {
    return this.model.AccountID;
  }
  //mounted
  mounted() {
    // (window as any).order = this;
    this.Selected = JSON.parse(this.$route.query.Consumers as string);
    this.getContactList();
    this.loadBtrip();
    this.loadCharges();
    // this.loadInsurances();
    this.handlConsumers();
    this.seatLists = JSON.parse(JSON.stringify(this.seatList));
    // this.getBtripExtra();
  }
  beforeMount() {
    let query: any = this.$route.query;
    let model = this.model;
    model.ProductID = query.ProductId;
    model.BookingType = query.BookingType;
    model.VoyageType = query.VoyageType;
    model.ApplyArea = query.ApplyArea;
    model.ShoppingID = query.ShoppingID;
    model.ServiceType = query.ServiceType; // 第一次赋值
    model.ClientUniqueID = this.approvalCode as string;
  }
  formatDate(value: Date, format: string = this.$root.$t("mall_order_yueri1") as string) {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  // 点击遮罩层所做的操作
  onClickOverlay() {
    // 关闭弹窗
    this.show = false;
  }
  handlConsumers() {
    let consumers: RoleInfoEntity[] = [];
    this.consumers = [];
    this.Selected.forEach((consumer: any) => {
      if (consumer.ConsumerID && consumer.ConsumerID.length > 0) {
        return;
      }
      let roleInfo = roleUtils.BuildRole() as any;
      roleInfo.RoleName = consumer.ConsumerName;
      this.matchCards(roleInfo);
      consumers.push(roleInfo);
    });

    UserService.getConsumers()
      .then(response => {
        if (!response.isSucc || !response.result) return;
        let roles = response.result!;

        for (let i = 0; i < roles.length; i++) {
          let role = roles[i];
          let filters = this.Selected.filter((o: any) => o.ConsumerID == role.RoleID);
          if (filters.length > 0) {
            this.matchCards(role);
            consumers.push(role);
          }
        }
        this.RoleData = roles;
      })
      .then(() => {
        consumers.forEach(o => this.consumers.push({ ...o, BudgetCode: '', BudgetIntro: '', BudgetName: '' }));
      })
      .then(() => {
        if (this.consumers && this.consumers.length > 0) {
          this.roomNum = Math.ceil(this.consumers.length / this.roomCapacity);
        }
        if (this.roomNumber) {
            const roomNumber = Number(this.roomNumber);
            this.roomNum = roomNumber;
        }
      });
  }

  roleExtra(role: any) {
    if (role.SMSNotify === undefined) {
      this.$set(role, "SMSNotify", true);
    }
    return role;
  }

  roleToConsumer(role: RoleInfoEntity) {
    // let user= role as any;
    let consumer = role as any;
    let card = consumer.Cards.filter((o: any) => o.isActive)[0] as CardInfoEntity;
    let contact = consumer.ContactInfo as ContactInfoEntity;
    let passenger: any = {
      RoleID: role.RoleID,
      ConsumerID: role.RoleID,
      ConsumerType: ConsumerType.Young,

      Birthday: role.BirthDate,

      ContactMobile: contact.ContactPhone,
      ContactEmail: contact.ContactEmail,

      CardNo: card.CardNo,
      CardType: card.CardType,
      CardOverDate: moment(card.ExpireDate).format("YYYY-MM-DD"),

      ConsumerSex: role.RoleGenre,
      CountryID: role.Country || card.IssueCountry,

      CountryCode: consumer.CountryCode || "CN",
      NotifyType: consumer.SMSNotify ? "1865" : "",
      ConsumerPreference: "",
      MainlandCode: 86,
      IsSave: consumer.IsSave,
      BudgetCode: consumer.BudgetCode
    };

    if (card.CardType == 1298 || card.CardType == 1299 || card.CardType == 1139 || card.CardType == 1297) {
      if (card.EnglishFirstName && card.EnglishLastName) {
        passenger.EnglishFirstName = card.EnglishFirstName;
        passenger.EnglishLastName = card.EnglishLastName;
      } else {
        passenger.EnglishFirstName = role.FirstName;
        passenger.EnglishLastName = role.LastName;
      }
    } else if (card.CardType == 1234 || card.CardType == 1141 || card.CardType == 1233) {
      passenger.ConsumerName = card.RoleName || role.RoleName;
      passenger.EnglishFirstName = card.EnglishFirstName;
      passenger.EnglishLastName = card.EnglishLastName;
    } else {
      passenger.ConsumerName = card.RoleName || role.RoleName;
    }

    return passenger;
  }
  findCard(role: any) {
    return _.find(role.Cards, o => o.isActive);
  }
  matchCards(role: RoleInfoEntity) {
    var pass = role as any;
    pass.IsSave = true;
    pass.lang = "cn";
    let __self = this;

    let cardType = __self.model.ApplyArea == ApplyArea.Overseas ? CardType.PassportCard : CardType.IDCard;
    if (role.RoleID != null && __self.model.ApplyArea == ApplyArea.Internal && pass.Cards && pass.Cards.length) {
      let cards = pass.Cards.filter((o: any) => o.CardNo && o.CardNo != "" && !/^\s+$/.test(o.CardNo));
      if (cards && cards.length) {
        let card = _.find(cards, o => o.CardType == cardType) || cards[0];
        cardType = card.CardType;
      }
    }

    if ((cardType == CardType.PassportCard || cardType == CardType.ForeignResidentIDCard) && __self.model.ServiceType == ServiceType.FlightService) {
      pass.lang = "en";
    }
    let active = _.find(pass.Cards, o => o.CardType == cardType);
    if (!active) {
      active = roleUtils.BuildCard(cardType);
      pass.Cards.push(active);
    }
    active.isActive = true;
    return active;
  }
  gotoLogin() {
    location.href = "/login";
  }
  back() {
    history.back();
  }
  get isNeedCardNo() {
    return _.find(this.Products[0]?.Extras, item => item.ExtraCode == "Hotel.Throw.NeedCardNo");
  }

  ensureFallback(location: any) {
    removeKeepalive(this.$route.fullPath);
    history.replaceState({ target: "index" }, "index", "/");
    this.$router.push(typeof location == "string" ? { path: location } : location);
  }
  watchComplate(isSuccess: boolean, result: any) {
    if (isSuccess) {
      if (result && result.SelfPayment && result.SelfPayment > 0) {
        removeKeepalive(this.$route.fullPath);
        history.replaceState({ target: "index" }, "index", "/");
        this.$router.push({
          path: "/trade/cashier",
          query: {
            OrderID: result.OrderID,
            PartnerID: result.ClientID,
            UnionID: result.UnionID,
          },
        });
      } else {
        this.ensureFallback("/order/list");
      }
    }
  }

  isCheckApproval = false;
  isSkipCheckApproval = false;
  unkownConsumers: any[] = [];
  isShowUnkownConsumer = false;
  hideUnkownConsumer(isConfirm: boolean) {
    if (isConfirm) {
      this.submit();
    }
  }

  isOneSelf = false;
  isReadOnly = true;
  isLink12306 = false;
  verifyTimer: any = null;
  
  //提交/支付
  submit() {
    // 阻断程序执行
    /* (this.$refs.refWatchOrder as any).startWatch("", this);
    return; */

    let model = this.model;
    let __self = this;
    let approvalRule = this.ApprovalRule || "";
    this.model.CenterID = this.costCenter.RoleID!;
    this.model.IntentID = this.tripIntent.TextID!;
    this.model.ProjectCode = this.projectCode.ProjectCode!;
    this.model.Remark = this.demandContent;
    // 始终需要进行旅客信息映射
    this.model.Consumers = this.consumers.map((o: any) => this.roleToConsumer(o)) as [];
    // this.ApprovalRule += "1597";
    let message = "";
    if (approvalRule && approvalRule.indexOf("1543") > -1 && !model.CenterID && this.CostCenters && this.CostCenters.length > 0) {
      message += this.$root.$t("mall_order_qingxuanzechengbenzhongxin") as string + "\n";
      // return this.$root.$toast.fail(this.$root.$t("mall_order_qingxuanzechengbenzhongxin") as string);
    }
    // 自选审批人
      if (this.isEnableChooseApprovel) {
        if (this.isChooseApprovelRequired && this.FlowInfoData && this.FlowInfoData.Nodes && this.FlowInfoData.Nodes.length) {
          for (let i = 0; i < this.FlowInfoData.Nodes.length; i++) {
            var currentNode = this.FlowInfoData.Nodes[i];
            if (currentNode.SignCode != "and_sign") {
              if (!currentNode[activePropCode]) {
                message += `第${this.getNumberName(i)}级审批需要自选审批人\n`;
                // return this.$root.$toast.fail(`第${this.getNumberName(i)}级审批需要自选审批人`);
              }
            }
          }
        }
        this.model.chooseApprover = this.FlowInfoData.Nodes.map((node: any) => node[activePropCode] || "");
      }
      
      // 预算编码验证
      if (this.isShowBudgetCode) {
        let codeKey: any = this.model.Consumers.find((item: RoleInfoEntity) => item.BudgetCode === '');
        if (codeKey) message += `请为旅客 ${codeKey.ConsumerName} 选择预算编码\n`;
        // return this.$toast.fail(`请为旅客 ${codeKey.ConsumerName} 选择预算编码`);
      }
      
      // 附件上传验证
      let extrasKey = __self.model.ExtraInfos.length === 0;
      if (this.ApprovalRule && this.ApprovalRule.indexOf('1603') > -1 && extrasKey) {
        message += `请先上传订单附件\n`;
        // return this.$toast.fail(`请先上传订单附件`);
      }
      if (approvalRule && approvalRule.indexOf("1544") > -1 && !model.ProjectCode) {
        message += this.$root.$t("mall_order_qingtianxiexiangmudaima") as string + "\n";
        // return this.$root.$toast.fail(this.$root.$t("mall_order_qingtianxiexiangmudaima") as string);
      }
      if (approvalRule && approvalRule.indexOf("1582") > -1 && !model.ClientUniqueID) {
        message += this.$root.$t("mall_order_qingtianxieshenpidanhao") as string + "\n";
        // return this.$root.$toast.fail(this.$root.$t("mall_order_qingtianxieshenpidanhao") as string);
      }
      if (approvalRule && approvalRule.indexOf("1580") > -1) {
        if (!model.IntentID) {
          message += this.$root.$t("mall_order_qingtianxiechalvmude") as string + "\n";
          // return this.$root.$toast.fail(this.$root.$t("mall_order_qingtianxiechalvmude") as string);
        }
        let FeatureCode = this.tripIntent && (this.tripIntent.FeatureCode as string);
        if (model.IntentName == "" && FeatureCode && FeatureCode.indexOf("invisible") > -1) {
          message += this.$root.$t("mall_order_qingtianxiexiangqingmude") as string + "\n";
          // return this.$root.$toast.fail(this.$root.$t("mall_order_qingtianxiexiangqingmude") as string);
        }
      }

    for (let i = 0; i < model.Contrarys.length; i++) {
      let contrary = model.Contrarys[i] as any;
      let FeatureCode = contrary.Causes.FeatureCode;
      let CauseID = contrary.Causes.CauseID;
      contrary.CauseID = contrary.Causes.CauseID;
      contrary.CauseName = contrary.Causes.CauseName;
      contrary.FeatureCode = contrary.Causes.FeatureCode;
      if (approvalRule && approvalRule.indexOf("1540") > -1 && (CauseID == '' || !CauseID)) {
        message += `请选择违背”${this.resetTranslate(contrary.ContraryInfo)}“的原因\n`;;
        // return this.$root.$toast.fail(`第${i + 1}项` + this.$root.$t("mall_order_qingxuanzeweibeiyuanyin") as string);
      }
      if (approvalRule && approvalRule.indexOf("1540") > -1 && FeatureCode?.indexOf("invisible") > -1) {
        if (contrary.CauseDetails == null || contrary.CauseDetails == "") {
          message +=`请填写违背”${this.resetTranslate(contrary.ContraryInfo)}“的详情原因\n`;;
          // return this.$root.$toast.fail(this.$root.$t("mall_order_qingtianxieweibeixiangqingyuanyin") as string);
        }
        // if (contrary.CauseDetails.length < 5) {
        //   if(model.Contrarys.length>1){
        //     message += `第${i + 1}项` + this.$root.$t("详细原因长度要求5~200个字符") as string + "\n";
        //   }else{
        //     message += this.$root.$t("详细原因长度要求5~200个字符") as string + "\n";
        //   }
        // }
      }
    }

    if (this.ServiceType == ServiceType.FlightService) {
      let isCanNdc = this.Products.filter(flight => flight.ProduceCode!.indexOf("MU") > -1 || flight.ProduceCode!.indexOf("FM") > -1 || flight.ProduceCode!.indexOf("KN") > -1);
      this.unkownConsumers.splice(0, this.unkownConsumers.length);
      for (let c = 0; c < this.model.Consumers.length; c++) {
        const consume = this.model.Consumers[c] as any;
        if (isCanNdc && consume.CardType != CardType.IDCard && moment(consume.Birthday).isAfter(moment().add(-6, "year"))) {
          Dialog.alert({ message: `系统暂不支持6岁以下儿童及婴儿机票预定，请确认旅客的出生日期是否正确，如有需要请联系客服！` });
          return;
        }
        if (isCanNdc && consume.CardType != CardType.IDCard && moment(consume.Birthday).isBefore(moment().add(-90, "year"))) {
          Dialog.alert({ message: `系统暂不支持90岁以上旅客机票预定，请确认旅客的出生日期是否正确，如有需要请联系客服！` });
          return;
        }
        if (consume.CardType != CardType.IDCard && !localStorage.getItem(`${md5(consume.CardNo)}`)) {
          this.unkownConsumers.push(consume);
        }
      }
    }
    if (message != "") {
      Dialog.alert({
        message: message,
        closeOnPopstate: true,
        confirmButtonText: "我已知晓",
      })
        .then(() => { }) // on confirm
        .catch(() => { }); // on cancel
      return;
    }
    if (this.unkownConsumers.length > 0) {
      this.isShowUnkownConsumer = true;
      return;
    }
    // console.log('submit')
    // return;

    // this.model.CenterID = this.costCenter.RoleID!;
    // this.model.IntentID = this.tripIntent.TextID!;
    // this.model.ProjectCode = this.projectCode.ProjectCode!;
    // this.model.Remark = this.demandContent;

    // this.model.IntentName = this.tripIntent.TextName!;
    // this.model.Extras = [];


    if (!this.isShowApprovalIDControl && !this.approvalCode) {
      this.model.ClientUniqueID = "";
    }
    // 需要再能填写商旅信息时验证证
    if (this.isLightCat && approvalRule && approvalRule.indexOf("1597") > -1 && this.model.ClientUniqueID && !/[a-z]{4}\d{12}/gi.test(this.model.ClientUniqueID) && !this.approvalCode) {
      Dialog.alert({
        message: "审批单号格式错误，请填写正确的审批单号，若没有审批单号，可以选择无审批凭证!",
        closeOnPopstate: true,
      })
        .then(() => { })
        .catch(() => { });
      return;
    }
    // 需要再能填写商旅信息时验证证
    if (
      this.isShowApprovalIDControl &&
      !this.isSkipCheckApproval &&
      approvalRule &&
      approvalRule.indexOf("1597") > -1 &&
      ((!this.isCheckApproval && this.isIWorkerApproved) || !__self.model.ClientUniqueID)
    ) {
      let skipCheckSubmit = () => {
        this.isSkipCheckApproval = true;
        this.submit();
        this.isSkipCheckApproval = false;
      };
      let checkTips = () => {
        Dialog.confirm({
          confirmButtonText: "修改审批单号",
          cancelButtonText: "继续提交订单",
          cancelButtonColor: "#ff6c6c",
          message: (this.approvalStatusMessage || "审批单号无效或无审批单号").replace("!", "") + "，继续提交订单需要行政助理审批此订单?",
          closeOnPopstate: true,
        })
          .then(() => { })
          .catch(() => {
            skipCheckSubmit();
            return;
          });
      };
      if (!this.isCheckApproval && __self.model.ClientUniqueID && !this.approvalCode) {
        this.checkApproval().then(json => {
          if (!this.isCheckApproval && __self.model.ClientUniqueID && !this.approvalCode) {
            checkTips();
          } else {
            skipCheckSubmit();
          }
        });
        return;
      }
      checkTips();
      return;
    }
    /* // 点击确认-显示弹窗
    this.show = true;
    console.log("弹窗显示"); */

    // return this.$root.$toast.fail("订单提交");

    // if ($utils.Storage.TripIntents) {
    // let TripIntents = JSON.parse($utils.Storage.TripIntents);
    // __self.model.IntentID = TripIntents.TextID;
    // } else {
    //   return $utils.fail(__self.$t('share.fail.TravelPurpose'), 'fail');
    // }
    // 如果保险有强绑项，则必须选择保险
    // let selecteds = _.filter(this.insurances, (item: any) => item.BundleSale == YesOrNo.Yes);
    // if(selecteds.length > 0 && !this.insurance) {
    //   if (model.ServiceType == ServiceType.FlightService) {
    //     this.$root.$toast.fail(this.$root.$t("mall_order_ghbjpwzhxscpnxxzyzbx") as string);
    //   } else if (model.ServiceType == ServiceType.TrainService) {
    //     this.$root.$toast.fail(this.$root.$t("mall_order_gcczxwzhxscpnxxzyzbx") as string);
    //   }
    //   return;
    // }
    // if ( this.insurance.Goods && !this.insurance.Goods[0].Prices[0].ProductID) {
    //   if (model.ServiceType == ServiceType.FlightService) {
    //     this.$root.$toast.fail(this.$root.$t("mall_order_ghbjpwzhxscpnxxzyzbx") as string);
    //   } else if (model.ServiceType == ServiceType.TrainService) {
    //     this.$root.$toast.fail(this.$root.$t("mall_order_gcczxwzhxscpnxxzyzbx") as string);
    //   }
    //   return;
    // }

    this.model.Consumers = this.consumers.map((o: any) => this.roleToConsumer(o)) as [];
    if (__self.isNeedCardNo && (model.Consumers[0] as any).CardNo == "") {
      return this.$root.$toast.fail(this.$root.$t("mall_order_qingtianxielvkezhengjianhaoma") as string);
    }
    //下单时提取座位信息
    if (model.ServiceType == ServiceType.TrainService) {
      if (!__self.isLink12306) {
        this.overlayShow = true;
        let isSkipCheckApproval = this.isSkipCheckApproval;
        (this.$refs.trainActStatus as any).validOuterUserAct(true).then((isLink12306: boolean) => {
          __self.overlayShow = false;
          __self.isLink12306 = isLink12306;
          if (isLink12306) {
            __self.isSkipCheckApproval = isSkipCheckApproval;
            __self.submit()
            __self.isLink12306 = false;
            return;
          }
        }).catch(() => {
          __self.overlayShow = false;
        });
        return;
      }


      this.model.seat_type = this.LevelCode as string;
      this.model.TrainSeatNo = "";
      for (var m = 0; m < this.seatLists.length; m++) {
        for (var i = 0; i < this.seatLists[m].data.length; i++) {
          if (this.seatLists[m].data[i].currentFlag) {
            this.model.TrainSeatNo = `${this.model.TrainSeatNo + (m + 1)}${this.seatLists[m].data[i].select}`;
          }
        }
      }
      this.model.TrainSeatNo = this.model.TrainSeatNo.replace(/,$/g, "");
      if (this.model.TrainSeatNo != "" && this.model.TrainSeatNo.length / this.model.Consumers.length != 2) {
        return this.$toast.fail(this.$t("share.fail.SelectSeat"));
      }
    }

    if (this.charge && this.charge.Goods) {
      this.model.Extras.push({ ServiceType: ServiceType.ChargeService, ThrowID: this.charge.Goods[0].Prices[0].ProductID });
    }
    // 处理保险产品
    // __self.model.Extras.forEach(item=>{
    //     delete item.isBundle;
    // });
    __self.model.Extras = __self.model.Extras.filter(item=>(item.ThrowID && item.ServiceType==1466) || item.ServiceType!=1466);
    this.overlayShow = true;
    if (this.ServiceType == ServiceType.FlightService) {
      this.CheckRepeatOrder(flightService, this.model);
    }
    //hotel
    else if (this.ServiceType == ServiceType.HotelService) {
      if(this.hasGoodRefundRule){
        this.overlayShow = false;
        this.showSubOrder = true;
        return
      }
      const query = this.$route.query;
      const hotelDatas = this.model as any;
      // hotelDatas.ProductID = query.ProductId;
      hotelDatas.PolicyID = query.PolicyID;
      hotelDatas.ProduceID = query.ThrowID;
      hotelDatas.RoomNum = this.roomNum;
      hotelDatas.ThrowId = query.ThrowID;
      this.CheckRepeatOrder(hotelService, hotelDatas);
    }
    //train
    else {
      //验证身份信息
      this.model.Consumers.map((consumer: any) => {
        if (!consumer.ConsumerName) {
          consumer.ConsumerName = consumer.EnglishFirstName + "/" + consumer.EnglishLastName;
        }
      });
      trainService.ConsumerVerification(this.model.Consumers).then(res => {
         if (!res.isSucc) {
            this.overlayShow = false;
            let message = res && (res.message as string);
            if (!message) {
              message = res.result[0].Message;
            }
            // this.$root.$alert(message);
            this.$dialog
              .alert({
                message: message,
                closeOnPopstate: true,
              })
              .then(() => { })
              .catch(() => { });

            // this.$root.$toast(message);
          } else {
            this.CheckRepeatOrder(trainService, this.model);
        }
      });
    }
  }
  // 判断是否存在符合条件的退款规则
  get hasGoodRefundRule() {
      let __self = this;
      // 遍历Policys数组
      for (let i = 0; i < __self.policys.length; i++) {
          let policy = __self.policys[i] as any;
          // 遍历Products数组
          if (policy.Products && policy.Products.length > 0) {
              for (let j = 0; j < policy.Products.length; j++) {
                  let product = policy.Products[j];
                  // 遍历Extras数组
                  if (product.Extras && product.Extras.length > 0) {
                      for (let k = 0; k < product.Extras.length; k++) {
                          let extra = product.Extras[k];
                          // 检查是否符合条件
                          if (extra.ExtraCode === "Hotel.Policy.GoodRefundRuleName" && extra.ExtraData !== "限时取消") {
                              return true;
                          }
                      }
                  }
              }
          }
      }
      return false;
  }
  confirmSubOrder(){
    this.showSubOrder = false;
    const query = this.$route.query;
    const hotelDatas = this.model as any;
    // hotelDatas.ProductID = query.ProductId;
    hotelDatas.PolicyID = query.PolicyID;
    hotelDatas.ProduceID = query.ThrowID;
    hotelDatas.RoomNum = this.roomNum;
    hotelDatas.ThrowId = query.ThrowID;
    this.CheckRepeatOrder(hotelService, hotelDatas);
  }
  //验证重复单
  CheckRepeatOrder(service: any, productData: object) {
    // 调用方法
    service.CheckRepeatOrder(productData).then((res: any) => {
      if (res.result != null && res.result.length > 0) {
        // 提示 - 点击确认时触发
        Dialog.confirm({
          title: this.$root.$t("mall_order_wenxintishi") as string,
          message: this.$root.$t("mall_order_shifoujixuyuding", [res.result[0]]) as string,
          // 页面回退时自动关闭
          closeOnPopstate: true,
        })
          .then(() => {
            this.overlayShow = false;
            // 点击确认-显示弹窗
            this.show = true;
            // 判断如果弹窗为false关闭之后，调用创建订单方法生成订单

            this.CreateOrder(service, productData);
          })
          .catch(() => {
            this.overlayShow = false;
            return;
          });
      } else {
        this.CreateOrder(service, productData);
      }
    });
  }
  // 声明一个假的函数用来做调用
  createOrderFnWrap = () => { };

  //创建订单前的弹窗提示
  CreateOrder(service: any, productData: object) {
    // 火车
    if (this.ServiceType == ServiceType.TrainService) {
      this.ExecuteCreateOrder(service, productData);
      return;
    }
    /*  if (this.ServiceType == ServiceType.FlightService) {
      this.ExecuteCreateOrder(service, productData);
      return;
    } */

    // 调用订单接口前显示弹窗,如果点击确定就执行下面的代码,如果点击遮罩层就关闭弹窗
    let __self = this;
    this.createOrderFnWrap = () => {
      __self.show = false;
      __self.ExecuteCreateOrder(service, productData);
    };

    // 点击确认-显示弹窗
    this.overlayShow = false;
    this.show = true;
  }

  //创建订单
  ExecuteCreateOrder(service: any, productData: object) {
    this.overlayShow = true;
    service.CreateOrder(productData).then((res: any) => {
      if (!res.isSucc) {
        this.overlayShow = false;
        // this.$root.$toast(res.message);
        Dialog.alert({
          message: res.message,
          closeOnPopstate: true,
        }).then(() => { });
        return;
      }
      this.overlayShow = false;
      if (this.ServiceType == ServiceType.TrainService) {
        (this.$refs.refWatchOrder as any).startWatch(res.result.UniqueID, this);
        return;
      }
      Dialog.alert({
        message: this.$root.$t("mall_order_ddcjcghynsszddxxzgzd") as string,
        closeOnPopstate: true,
      }).then(() => this.watchComplate(true, res.result));
    });
  }

  gotoTrainAccount() {
    this.$router.push("/mall/trainAccount");
  }
  //需求备注
  gotoRemarks() {
    this.$router.push("/mall/remarks");
  }
  editRole(role: any) {
    this.dataShare.editRole = role;
    (this.dataShare as any).ServiceType = this.model.ServiceType;
    let isReadOnly = this.isOneSelf || (this.isReadOnly && role.RoleID && role.RoleID != "" && role.RoleID.length > 10 ? true : false);
    this.$router.push(`/mall/editRole?isReadOnly=${isReadOnly}&approvalCode=${this.approvalCode}`);
  }
  //成本中心
  get costCenter(): RoleInfoEntity {
    return this.dataShare.costCenter;
  }
  set costCenter(value) {
    this.dataShare.costCenter = value;
  }
  chooseCostCenter() {
    this.$router.push("/mall/chooseCostCenter");
  }
  //差旅目的
  get tripIntent(): BtripTextEntity {
    return this.dataShare.tripIntent;
  }
  set tripIntent(value) {
    this.dataShare.tripIntent = value;
  }
  chooseTripIntent() {
    this.$router.push("/mall/chooseTripIntent");
  }

  get contraryReason(): BtripTextEntity {
    return this.dataShare.contraryReason;
  }
  set contraryReason(value) {
    this.dataShare.contraryReason = value;
  }

  // chooseIndex = 0;
  chooseContraryReason(contrary: any, index: number) {
    this.contraryReason = contrary;
    this.$router.push("/mall/chooseContraryReason");
  }

  //项目代码
  get projectCode(): ProjectEntity {
    return this.dataShare.projectCode;
  }
  set projectCode(value) {
    this.dataShare.projectCode = value;
  }
  chooseProjectCode() {
    this.$router.push(`/mall/chooseProjectCode?approvalCode=${this.approvalCode}`);
  }

  @Prop()
  policys!: [];

  //项目代码
  get ClientUniqueID(): string {
    return this.model.ClientUniqueID;
  }
  isInvalidApproval = false;

  isShowIWorkerApproved = false;
  isIWorkerApproved = true;

  isShowApprovalIDSelectControl = false;
  selectApprovalStatus(data: any) {
    this.isShowApprovalIDSelectControl = false;
    this.isShowApprovalIDControl = data.value;
  }
  selectIWorkerStatus(data: any) {
    this.isShowIWorkerApproved = false;
    this.isIWorkerApproved = data.value;
  }

  isShowApprovalIDSelectFlag = false;
  get isLightCat(): boolean {
    if (this.profile && this.profile.CompanyID) {
      return lightCat.indexOf(this.profile.CompanyID) > -1;
    }
    return false;
  }

  isShowApprovalIDControl = true;

  @Watch("ClientUniqueID")
  clientUniqueIDChange() {
    // this.isInvalidApproval = false;
    this.onChangeClientUniqueID();
  }
  ClientUniqueIDBlur() {
    // if (this.isLightCat) {
    //   if (this.model.ClientUniqueID && /[a-z]{4}\d{12}/gi.test(this.model.ClientUniqueID)) {
    //     this.checkApproval();
    //   } else if (this.isShowApprovalIDControl) {
    //     this.isInvalidApproval = true;
    //   }
    // } else {
    //   this.isInvalidApproval = false;
    // }
  }
  onChangeClientUniqueID() {
    let newValue = this.model.ClientUniqueID;
    this.approvalStatusMessage = "";
    if (!newValue) {
      this.isInvalidApproval = false;
      return;
    }
    // this.ApprovalRule += "1597";
    if (this.ApprovalRule && this.ApprovalRule.indexOf("1597") <= -1) {
      this.isInvalidApproval = false;
      return;
    }
    if (this.isLightCat && this.model.ClientUniqueID && /[a-z]{4}\d{12}/gi.test(this.model.ClientUniqueID)) {
      this.checkApproval();
    } else {
      this.isInvalidApproval = false;
    }
  }

  approvalStatusMessage: string = "";
  checkApproval() {
    return adapterService
      .checkApproval({
        ApprovelId: this.model.ClientUniqueID,
        UserName: this.profile.UserName,
        Users: this.consumers.map(o => o.RoleName),
        ServiceType: this.model.ServiceType,
      })
      .then(json => {
        this.isCheckApproval = json.isSucc; // || !this.isIWorkerApproved;
        this.isInvalidApproval = !json.isSucc && this.isIWorkerApproved;
        if (this.isInvalidApproval) {
          this.approvalStatusMessage = json.message!;
          // Dialog.alert({ message: this.approvalStatusMessage });
        }
        // return json;
        // if (!json.isSucc) {
        //   this.isInvalidApproval = true;
        // } else {
        //   this.isInvalidApproval = false;
        // }
      });
  }

  @Watch("policys")
  loadPolicys(value: []) {
    this.Products = value && value.length > 0 && (value as any)[0].Products;
    // 获取保险 
    if(this.policys.length > 0) this.loadInsurances();
    this.showServeHint();
    if(this.policys.length > 0) this.loadContrarys();
    if (this.consumers && this.consumers.length > 0) {
      this.roomNum = Math.ceil(this.consumers.length / this.roomCapacity);
    }
    if (this.roomNumber) {
         const roomNumber = Number(this.roomNumber);
         this.roomNum = roomNumber;
    }
  }
  @Watch("costCenter.RoleID", { deep: true })
  onChangeValue() {
   if(this.policys.length > 0 && this.costCenter.RoleID) this.loadBtrip(true);
  }

  ApprovalRule = "";
  ProjectID = "";
  CenterID = "";

  tripFlow: any = {};
  get Centers() {
    return this.tripFlow;
  }
  get RuleID() {
    return this.$route.query.RuleID;
  }
  get employees(): { ConsumerID: string; ConsumerName: string }[] {
    return this.Selected.filter((o: any) => o.ConsumerID);
  }
  get isShowProjectCode() {
    if (this.ApprovalRule && this.ApprovalRule.indexOf("1589") > -1) {
      return false;
    }
    return true;
  }

  get isShowApprovalNo() {
    return this.isShowApprovalIDControl && this.ApprovalRule && (this.ApprovalRule.indexOf("1582") > -1 || this.ApprovalRule.indexOf("1584") > -1);
  }

  get reviseTripIntent() {
    let __self = this;
    if (this.tripIntent.FeatureCode && this.tripIntent.FeatureCode.indexOf("invisible") > -1 && this.ApprovalRule && this.ApprovalRule.indexOf("1580") > -1) {
      return true;
    }

    return false;
  }

  get isViolate() {
    return this.model.Contrarys.length > 0;
  }
  get disableIntentTripApproval() {
    return this.ApprovalRule && (this.ApprovalRule.indexOf("1599") > -1);
  }
  get isShowBudgetCode() {
    return this.ApprovalRule && (this.ApprovalRule.indexOf("1601") > -1);
  }
  get isShowAttachment() {
    return this.ApprovalRule && (this.ApprovalRule.indexOf("1603") > -1 || this.ApprovalRule.indexOf("1605") > -1);
  }
  FeatureCodes = '';
  loadBtrip(isReload?: boolean) {
    let __self = this;
    let datas: any = { RuleID: __self.RuleID };
    if (!datas.RuleID) {
      datas.CompanyID = __self.profile.CompanyID;
      datas.ApplyArea = __self.model.ApplyArea;
      datas.ServiceType = __self.model.ServiceType;
      datas.Users = this.employees.map((o: any) => o.ConsumerID);
      datas.ApplyViolateRule = this.isViolate ? YesOrNo.No : YesOrNo.Yes; // no 1151 y 1150
      if (this.costCenter.RoleID) datas.CostCenterID = this.costCenter.RoleID;
    }

    let delayShow = setTimeout(() => {
      this.overlayShow = true;
    }, 300);
    btripServcice.getTripRule(datas).then(json => {
      clearTimeout(delayShow);
      if (!json.isSucc || !json.result) {
        this.overlayShow = false;
        return json;
      }
      var result = json.result;
      __self.ApprovalRule = result.ApprovalRule!;
      __self.FeatureCodes = result.FeatureCodes || '';
      __self.tripFlow = result.TripFlow;
      __self.isOneSelf = result.OneSelf == YesOrNo.Yes;
      // __self.isReadOnly = result.OneSelf == YesOrNo.Yes;

      if (isReload !== true) {
        let data = _.find(__self.dataShare.costCenters, (o: any) => o.RoleID == result.CostCenter);
        if (data) {
          __self.costCenter = data;
        }

        __self.ProjectID = result.ProjectCode!;
        __self.CenterID = result.CostCenter!;
      }
      this.getFlowInfo();

      if (isReload !== true) {
        this.loadTripIntent();
        this.loadCostCenter();
        this.loadProjectCode();
      }
    });
  }
  Reasons: any[] = [];

  //成本中心
  loadCostCenter() {
    let RootID = this.profile.CompanyID;
    const data = { PageSize: 999999, Superior: { RoleType: 1319, RootID: RootID }, RoleType: 1319 };
    UserService.getRoleList(data).then(res => {
      if (res.isSucc) {
        let costCenters = res.result!.entities! as any;
        this.dataShare.costCenters = _.orderBy(costCenters, ["UpdateTime"], ["desc"]) as any;
        this.loadUserCostCenter();
      }
    });
  }
  get CostCenters() {
    return this.dataShare.costCenters as RoleInfoEntity[];
  }
  set CostCenters(value: any) {
    this.dataShare.costCenters = value;
  }
  loadUserCostCenter() {
    let __self = this;
    let RoleIDs = this.employees.map((o: any) => o.ConsumerID);
    let where: any = {
      PageSize: 999999,
      RoleIDs: RoleIDs,
      RoleWith: RoleType.User,
      OwnerWith: RoleType.CostCenter,
      SpaceID: __self.profile.CompanyID,
    };
    UserService.getConferList(where).then(json => {
      if (!json.isSucc) {
        return;
      }

      let userCostCenters = _.orderBy(json.result!.entities!, ["UpdateTime"], ["desc"]);
      userCostCenters.forEach((o, i) => {
        __self.CostCenters.forEach((m: RoleInfoEntity, index: number) => {
          if (o.OwnerID == m.RoleID) {
            __self.CostCenters.splice(index, 1);
            __self.CostCenters.unshift(m);
          }
        });
      });
      if (this.dataShare.costCenters == undefined || this.dataShare.costCenters.length == 0) {
        return;
      }
      let list: RoleInfoEntity = {
        RoleID: "",
        RoleName: "",
      };
      if (__self.Centers) {
        if (__self.Centers.CenterCode == "TripRuleCenter") {
          let CenterIDs = __self.Centers.CenterID.split(",");
          __self.CostCenters = _.filter(__self.CostCenters, o => {
            let result = _.find(CenterIDs, m => m == o.RoleID) as any;
            if (result) {
              return o.RoleID == result;
            }
          });
          if (__self.CostCenters.length == 1) {
            list.RoleID = __self.CostCenters[0].RoleID;
            list.RoleName = __self.CostCenters[0].RoleName;
          }
        }
        if (__self.Centers.CenterCode == "ConsumerCenter") {
          __self.CostCenters = _.filter(__self.CostCenters, o => {
            let result = _.find(userCostCenters, m => m.OwnerID == o.RoleID) as any;
            if (result) {
              return o.RoleID == result.OwnerID;
            }
          });
          if (__self.CostCenters.length == 1) {
            list.RoleID = __self.CostCenters[0].RoleID;
            list.RoleName = __self.CostCenters[0].RoleName;
          }
        }
        if (__self.Centers.CenterCode == "CompanyCenter") {
          if (__self.CostCenters.length == 1) {
            list.RoleID = __self.CostCenters[0].RoleID;
            list.RoleName = __self.CostCenters[0].RoleName;
          }
        }
      }
      if (!__self.RuleID) {
        __self.costCenter = list;
      } else {
        let data = _.find(__self.CostCenters, o => o.RoleID == __self.costCenter.RoleID!);
        let RoleID = __self.costCenter.RoleID;
        if (data) {
          __self.costCenter = {
            RoleName: data.RoleName,
            RoleID: RoleID,
          };
        } else {
          __self.costCenter = {
            RoleName: RoleID,
            RoleID: RoleID,
          };
        }
      }
      // __self.value.CenterID = __self.CostCenter.RoleID;
    });
  }

  FlowInfoData: any = {};

  getFlowInfo() {
    let flowID = this.tripFlow.FlowID;

    let delayShow = setTimeout(() => {
      this.overlayShow = true;
    }, 500);
    UserService.getFlowInfo(flowID).then(async json => {
      if (!json.isSucc || !json.result) {
        clearTimeout(delayShow);
        this.overlayShow = false;
        return json;
      }
      let flowInfo: any = json.result;

      // flowInfo.Nodes -- 审批节点
      const promises: any[] = [];

      _.forEach(flowInfo.Nodes, (node: any) => {
        node[activePropCode] = "";
        _.forEach(node.Roles, role => {
          promises.push(
            UserService.getNameList([role.RoleID]).then(info => {
              if (info.isSucc && info.result && info.result.length > 0) {
                Object.assign(role, info.result[0]);
              }
            })
          );
          // promises.push(
          //   UserService.getRoleInfo({ RoleID: role.RoleID }).then(info => {
          //     if (info.isSucc) {
          //       Object.assign(role, info.result);
          //     }
          //   })
          // );
        });
      });

      await Promise.all(promises);

      this.FlowInfoData = flowInfo;
      clearTimeout(delayShow);
      this.overlayShow = false;
    });
  }
  Nodeindex = 0;
  showApprovels: any[] = [];

  // test() {
  //   _.forEach(this.FlowInfoData.Nodes, (item: any) => {
  //     console.log(item);
  //   });
  //   let __self = this;
  //   for (let i = 0; i < __self.FlowInfoData.Nodes.length; i++) {
  //     __self.Nodeindex = i;
  //     let RoleInfos = __self.FlowInfoData.Nodes[i].RoleInfo[i];
  //     console.log("lalalalla", RoleInfos);

  //     //  for (let t = 0; t < RoleInfos.length; t++) {
  //     //    console.log('艹',RoleInfos[t]);

  //     //   //  let RoleNames: any[] = []
  //     //   //  RoleNames.push(RoleInfos[t].RoleName)
  //     //   //  __self.showApprovels[this.Nodeindex] = RoleNames
  //     //  }
  //   }
  //   console.log("哎哎哎", __self.showApprovels);
  // }

  //项目代码
  loadProjectCode() {
    let __self = this;
    // btripServcice.getProjectList({ OwnerID: this.profile.CompanyID, PageSize: 999 } as any).then(json => {
    //   if (json.isSucc) {
    //     let projectCodes = json.result!.entities!;
    //     let project = _.find(projectCodes, o => o.ProjectID == __self.ProjectID);

    //     let ProjectID = __self.ProjectID;
    //     if (project) {
    //       __self.projectCode = project;
    //     } else {
    //       __self.projectCode = {
    //         ProjectCode: ProjectID,
    //         ProjectID: ProjectID,
    //       };
    //     }
    //     this.dataShare.projectCodes = projectCodes as any;
    //   }
    // });
    btripServcice.SearchUserProjects({ OwnerID: this.profile.CompanyID, PageSize: 999 } as any).then(json => {
      if (json.isSucc) {
        let projectCodes = json.result;
        let project = _.find(projectCodes, o => o.ProjectID == __self.ProjectID);

        let ProjectID = __self.ProjectID;
        if (project) {
          __self.projectCode = project;
        } else {
          __self.projectCode = {
            ProjectCode: ProjectID,
            ProjectID: ProjectID,
          };
        }
        this.dataShare.projectCodes = projectCodes as any;
      }
    });
  }

  //差旅目的
  loadTripIntent() {
    let __self = this;
    const data = this.model.ServiceType.toString();
    btripServcice.getBtripTexts(data).then(json => {
      if (json.isSucc) {
        let tripIntents = [];
        let contraryReasons = [];
        for (let j = 0; j < json.result!.length; j++) {
          var element = json.result![j];
          if (element.TextType == TravelReasonType.TravelPurpose) {
            tripIntents.push(element);
          }
          if (element.TextType == TravelReasonType.PolicyCause) {
            contraryReasons.push(element);
          }
        }

        this.dataShare.tripIntents = tripIntents as any;
        this.dataShare.contraryReasons = contraryReasons as any;

        if (tripIntents.length > 0) {
          __self.tripIntent = tripIntents[0];
        }
      }
    });
  }

  loadContrarys() {
    let __self = this;
    let Contrarys:any[] = [];
    for (let i = 0; i < __self.policys.length; i++) {
      const policy = __self.policys[i] as any;
      for (let j = 0; j < policy.Products.length; j++) {
        const product = policy.Products[j];
        let features = _.filter(product.Features, feature => feature.FeatureCode == "Btrip").map(o => o.FeatureData);
        let localContrarys = this.dataShare.localContrarys;
        let conformGoods = this.dataShare.conformGoods;
        if (localContrarys && localContrarys.length > 0) {
          _.forEach(localContrarys, item => {
            if (product.SourceID.indexOf(item.SourceID) != -1) {
              let conforms = conformGoods.filter((goods: any) => goods.SourceID == item.SourceID && product.SourceID.indexOf(goods.GoodsID) != -1);
              if (!conforms || conforms.length == 0) {
                features.push(item.ContraryInfo);
              }
            }
          });
        }
        if (features.length <= 0) {
          continue;
        }

        const configKey = __self.FeatureCodes && (__self.FeatureCodes.indexOf("ContraryReasonSeparateSelect") > -1);

        if (configKey) {
          // 有单选每条原因配置项
          const newFeatures: any[] = features.map(item => {
            return {
              ContraryInfo: item,
              Causes: {
                FeatureCode:'',
                CauseName:'',
                CauseID:''
              },
              CauseDetails: '',
              CauseID: "",
              CauseName: "",
              FeatureCode: '',
              ProductID: product.SourceID,
              ProductName: product.ProductName,
            }
          })
          Contrarys.push(...newFeatures);

        } else {
          Contrarys.push({
            ContraryInfo: features.join(","),
            ProductID: product.SourceID,
            ProductName: product.ProductName,
            CauseID: "",
            CauseDetails: "",
            CauseName: "",
            Causes: {
                FeatureCode:'',
                CauseName:'',
                CauseID:''
              },
            FeatureCode: '',
          });
        }
      }
    }

    __self.model.Contrarys = Contrarys;
    // 违背原因获取后重新获取审批流程
    this.loadBtrip(true);
  }

  //保险
  insurances:any[] = [];
  insurance: any = [];
  showInsurances = false;
  get isShowInsurance(): boolean {
    if (this.insurances.length == 0) {
      return false;
    }
    return !this.showInsurances;
  }

// 获取所有保险
  loadInsurances() {
    let __self = this;
    let data: any = {
      ProductID: __self.model.ProductID,
      BookingType: __self.model.BookingType,
      VoyageType: __self.model.VoyageType,
      ApplyArea: __self.model.ApplyArea,
      ConsumerCount: __self.consumers.length,
      ServiceType: __self.model.ServiceType,
    };
    insurancePolicyService.getProductInfo(data).then(json => {
      if (!json.isSucc) {
        return json;
      }
      let insurances = json.result as PolicyInfoEntity[];

      setTimeout(() => {
      // 筛选强绑的数据
      let BundleInsuranceProducts = _.filter(insurances, (item: any) => item.BundleSale == YesOrNo.Yes);
      const SourceIDs = __self.policys.map((item:any)=>{
          const SourceIDs = item.Products.map((product:any)=> product.SourceID)
          return SourceIDs
       }).flat()
        // 把每个强绑保险中的产品最低价选出
        const minProducts = insurances.map((item:any)=>{
           const minPic = item.Goods.map((goods:any)=>{
                return goods.Prices.reduce((a:any, b:any) => a.SalesPrice < b.SalesPrice ? a : b)
            })
            const newItem = { ...item }  // 浅拷贝
            newItem.Goods = minPic[0]
            return newItem
        })
        // 判断所有产品是否都是强绑产品
        const isAllBundle = SourceIDs.every(id=>{
           const key = insurances.some((item:any)=>item.BundleSale == '1150' && item.SourceID == id)
            return key
        })
        __self.showInsurances = isAllBundle;
        if(isAllBundle){
        // 所有产品都是强绑
            // 给每个产品 绑定最低价的保险产品
           const productExtras = SourceIDs.map(id=>{
                // 找到每个航程对应的最小价格产品
                const minProduct = minProducts.filter(item=> item.SourceID == id && item.BundleSale === '1150').reduce((a, b) => a.Goods.SalesPrice < b.Goods.SalesPrice ? a : b);
                return {SourceID:id,ProductID:minProduct.Goods.ProductID,FeatureCodes:minProduct.FeatureCodes}
            })

            // 保险产品一样的情况下 去重
            const uniqueProductExtras = __self.mergeByProductID(productExtras);
            uniqueProductExtras.forEach((item:any) => {
            __self.insurance.push(item.ProductID);
                __self.model.Extras.push({
                    ServiceType: ServiceType.InsuranceService,
                    ThrowID: item.ProductID,
                    ProductIds: item.SourceIDs,
                    isBundle: true
                });
            });
        }else{
        // 不是所有产品都是强绑
        //强绑产品直接默认选中
         const betterSourceIDs = SourceIDs.filter(id=> BundleInsuranceProducts.some((item:any)=>item.SourceID == id));
         if(betterSourceIDs.length > 0){
            betterSourceIDs.forEach(id=>{
                const minProduct = minProducts.filter(item=> item.SourceID == id && item.BundleSale === '1150').reduce((a, b) => a.Goods.SalesPrice < b.Goods.SalesPrice ? a : b);
                __self.insurance.push(minProduct.Goods.ProductID);

                __self.model.Extras.push({
                    ServiceType: ServiceType.InsuranceService,
                    ThrowID: minProduct.Goods.ProductID,
                    ProductIds: [id],
                    isBundle: true
                });
            })
         }
         const worSourceIDs = SourceIDs.filter(id=> !BundleInsuranceProducts.some((item:any)=>item.SourceID == id));
        //  非强绑产品和无保险
        if(worSourceIDs.length > 0){
                 // 给每个产品 绑定最低价的保险产品
           let productExtras = worSourceIDs.map(id=>{
            const filteredProducts = minProducts.filter(item => item.SourceID === id && item.BundleSale === '1151');
            if (filteredProducts.length === 0) return '';
                // 找到每个航程对应的最小价格产品
                const minProduct = minProducts.filter(item=> item.SourceID == id && item.BundleSale == '1151').reduce((a, b) => a.Goods.SalesPrice < b.Goods.SalesPrice ? a : b);
                return {SourceID:id,ProductID:minProduct.Goods.ProductID,FeatureCodes:minProduct.FeatureCodes}
            })
            productExtras = productExtras.filter(item => item !== ''); // 过滤掉空值
            if(productExtras.length > 0) {
              // 保险产品一样的情况下 去重
              const uniqueProductExtras = __self.mergeByProductID(productExtras);
               uniqueProductExtras.forEach((item:any) => {
                  // 如果是默认选中 则自动勾选
              if(item.FeatureCodes == "selectedDefault") __self.insurance.push(item.ProductID);
                  __self.model.Extras.push({
                      ServiceType: ServiceType.InsuranceService,
                      ThrowID:item.FeatureCodes == "selectedDefault" ? item.ProductID:'',
                      ProductIds: item.SourceIDs,
                      isBundle: false
                  });
              });
            }; // 如果没有非强绑产品，直接返回
        }
        }
      }, 200);
      // 去重
      __self.insurances =  _.uniqBy(insurances, 'PolicyID') as any;
    });
  }
    mergeByProductID(data:any[]) {
                const grouped = data.reduce((acc, item) => {
                const key = item.ProductID;
            if (!acc[key]) {
                // 初始化分组
                acc[key] = { SourceIDs: [item.SourceID], ProductID: key,FeatureCodes: item.FeatureCodes };
            } else {
                // 合并 SourceID
                acc[key].SourceIDs.push(item.SourceID);
            }
            return acc;
                }, {});

            return Object.values(grouped);
            }
             resetFlights(flightIds:string[] | undefined) {
                let __self = this;
                if (!flightIds || flightIds.length === 0) return '';
                const flightCodes:any = []
                // 所有航程id数组
                 __self.policys.forEach((item:any)=>{
                    const flights = item.Products.filter((product:any)=> flightIds.includes(product.SourceID))
                    flightCodes.push(...flights)
                 })
               return flightCodes.map((item:any)=>{
                    return item.ProduceCode + item.BatchCode;
                 }).join('/')
            }
  selectInsurance(insuranceI: any, extras: any) {
    const __self = this;
    if(extras.isBundle){
    this.$toast.fail('该保险为组合销售产品，不可取消');
    return;
    }
    if(extras.ThrowID === insuranceI.PolicyID) return extras.ThrowID = '';
    extras.ThrowID = insuranceI.PolicyID;
  }
  get insurancePrice() {
  let __self = this;
  let totalPrice =0;
  for (let i = 0; i < __self.model.Extras.length; i++) {
    let Extra = __self.model.Extras[i];
    if (Extra.ServiceType == ServiceType.InsuranceService && __self.insurances) {
       __self.insurances.forEach((o) => {
            o.Goods.forEach((i:any) => {
              const minPrice =  i.Prices.find((p:any) => p.SourceID == Extra.ThrowID);
              if (minPrice) totalPrice += minPrice.SalesPrice * (Extra.ProductIds?.length || 1);
            })
      })
    }
  }
  return totalPrice;
  }

  //服务费
  charge: any = {
    Goods: [
      {
        Prices: [
          {
            // ClientPriceID: null,
            // FeatureCode: null,
            // GoodsID: null,
            // GroupCode: null,
            MarketPrice: 0,
            // OrderID: null,
            // OriginID: null,
            // PriceCode: null,
            // PriceID: null,
            // PriceName: null,
            PriceType: PriceType.TicketFare,
            // ProductID: null,
            SalesPrice: 0,
            // SourceID: null,
            // StandardPrice: null,
            SupplyPrice: 0,
            // SupplyPriceID: null,
            // UniqueID: null,
          },
        ],
      },
    ],
  };
  loadCharges() {
    let __self = this;
    let data: any = {};
    data.ServiceType = __self.model.ServiceType;
    data.BusinessType = BusinessType.Sales;
    data.ApplyArea = __self.model.ApplyArea;
    data.VoyageType = __self.model.VoyageType;
    data.BookingType = __self.model.BookingType;
    data.ProductID = __self.model.ProductID;
    data.ConsumerCount = __self.consumers.length;
    data.ProduceID = this.$route.query.ThrowID;

    chargePolicyService.getProductInfo(data, { failTips: false }).then(json => {
      if (json.isSucc && json.result && json.result.length > 0) {
        let result = json.result as any;
        this.charge = result[0];
        this.charge.Products[0].Extras.forEach((item: any) => {
          if (item.ExtraCode === "Hotel.Throw.NeedCardNo" && item.ExtraData === "true") {
            return (this.isNeed = true);
          } else {
            return (this.isNeed = false);
          }
        });
      }
    });
  }
  get chargePrice() {
    let __self = this;
    if (!__self.charge) {
      return 0;
    }
    return __self.charge.Goods[0].Prices[0].SalesPrice;
  }

  contacts: ContactInfoEntity[] = [];
  getContactList() {
    let __self = this;
    let data = {
      RoleID: __self.profile.UserID,
    };
    UserService.getContactList(data).then(function (json) {
      if (json.isSucc) {
        let contacts = json.result!.entities!;
        for (let i = 0; i < contacts.length; i++) {
          let contact = contacts[i];
          __self.model.ContactName = contact.ContactPeople!;
          __self.model.ContactPhone = contact.ContactPhone!;
          __self.model.ContactEmail = contact.ContactEmail!;
        }
        __self.contacts = contacts;
      }
    });
  }

  calcPrice(price: number) {
    let __self = this;
    let results = 0;
    let policys = __self.policys as any;
    if (__self.model.ServiceType == ServiceType.HotelService) {
      results = price * this.GoodsCount;
    } else if (__self.model.ServiceType == ServiceType.FlightService) {
      for (var i = 0; i < policys.length; i++) {
        for (var m = 0; m < policys[i].Products.length; m++) {
          var product = policys[i].Products[m];
          if (product.Products && product.Products.length > 0) {
            results = results + price * product.Products.length * __self.consumers.length;
          } else {
            results = results + price * __self.consumers.length;
          }
        }
      }
    } else {
      results = price * __self.policys.length * __self.consumers.length;
    }
    return results;
  }

  get totalProductPrice() {
    let __self = this;
    if (!__self.policys) {
      return 0;
    }
    let SumPrices = 0;

    let policys = __self.policys as any;
    if (__self.model.ServiceType == ServiceType.HotelService) {
      for (let j = 0; j < policys.length; j++) {
        let policy = policys[j];
        for (let i = 0; i < policy.Goods.length; i++) {
          let goods = policy.Goods[i];
          for (let a = 0; a < goods.Prices.length; a++) {
            let price = goods.Prices[a];
            SumPrices += price.SalesPrice;
          }
        }
      }
      SumPrices = SumPrices * this.GoodsCount;
    } else {
      __self.consumers.forEach(value => {
        for (let j = 0; j < policys.length; j++) {
          let policy = policys[j];
          for (let i = 0; i < policy.Goods.length; i++) {
            let goods = policy.Goods[i];
            if (goods.GoodsType != ConsumerType.Young) {
              continue;
            }
            for (let j = 0; j < goods.Prices.length; j++) {
              let price = goods.Prices[j];
              SumPrices += price.SalesPrice;
            }
          }
        }
      });
    }
    return SumPrices;
  }

  get totalPrice() {
    let __self = this;
    let totalChargePrice = this.calcPrice(this.chargePrice);
    // 已经计算过航程 这里仅乘以人数即可
    let totalInsurancePrice = this.insurancePrice * __self.consumers.length;

    let ServicePrice = Math.round(totalChargePrice + totalInsurancePrice + this.totalProductPrice);
    let total = Math.round(ServicePrice);
    if (total) {
      return total;
    }
    return this.$root.$t("mall_order_hejiazhong") as string;
  }

  decoratePrice(Prices?: any) {
    let results: any[] = [];
    _.map(_.groupBy(Prices, "PriceType"), o => {
      let result = Object.assign({}, o[0]);
      result.SalesPrice = _.sumBy(o, "SalesPrice");
      result.PriceType = Math.round(result.SalesPrice);
     if(result.PriceCode) result.PriceName = this.$t(`mall.${result.PriceCode}`) as string;
      results.push(result);
    });
    return results;
  }

  // getSalesPrice(Price?: any, Prices?: any) {
  //   console.log(Prices);
  //   debugger;
  //   if (Price.PriceCode != "TicketFare") {
  //     return Price.SalesPrice;
  //   }
  //   let directReduction = _.find(Prices, item => item.PriceCode == "DirectReduction");
  //   if (directReduction) {
  //     return Price.SalesPrice + directReduction.SalesPrice;
  //   }
  //   return Price.SalesPrice;
  // }

  //房间数量选择
  selectRoomNum(num: number) {
    if(this.roomNumber) return;
    if (num * this.roomCapacity < this.consumers.length) {
      this.$toast.fail("总入住人数需小于房间可入住人数");
      return;
    }
    if (num > this.consumers.length) {
      this.$toast.fail(this.$root.$t("mall_order_fangjianshubukedayuruzhurenshu") as string);
      return;
    }
    this.roomNum = num;
  }

  extractExtra(code: string, policys?: any) {
    if (!policys || !policys[0] || !policys[0] || !policys[0].Products || !policys[0].Products[0]) {
      return "";
    }
    let rule = _.find(policys[0].Products[0].Extras, item => item.ExtraCode == code);
    if (rule && rule.ExtraData) {
      return rule.ExtraData;
    }
    return "";
  }

  get chooseApproveColumns() {
    return (this.activeNode.Roles || []).filter(o => o.DutyCode == DutyCode.Executer);
  }
  get chooseApproveTitle() {
    return `${this.getNumberName(this.activeNodeIndex)}级审批`;
  }

  activeNodeIndex = 0;
  activeNode: FlowNodeEntity = {};

  get isEnableChooseApprovel() {
    return this.ApprovalRule && (this.ApprovalRule.indexOf("1587") != -1 || this.ApprovalRule.indexOf("1588") != -1);
  }
  get isChooseApprovelRequired() {
    return this.ApprovalRule && this.ApprovalRule.indexOf("1588") != -1;
  }

  get isCostCenterRequire() {
    return this.ApprovalRule && this.ApprovalRule.indexOf("1543") > -1;
  }
  get isDisplayChooseApprovel() {
    if (!this.isEnableChooseApprovel) return false;
    if (this.isCostCenterRequire && (!this.costCenter || !this.costCenter.RoleID)) {
      //必需选择成本中心但是还没有选择的情况下 不显示审批人
      return false;
    }
    return true;
  }

  getNumberName(index: number) {
    // const numMap = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
    const numMap = ["one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten"];
    return this.$t(`${numMap[index]}`);
  }
  isEnableChoose(currentNode: FlowNodeEntity) {
    return this.isEnableChooseApprovel && currentNode.SignCode != "and_sign" ? "" : "disableChoose";
  }
  showChooseApprovel(currentNode: FlowNodeEntity, index: number) {
    this.activeNodeIndex = index;
    this.activeNode = currentNode;

    if (!this.isEnableChooseApprovel) {
      return this.$notify({ type: "warning", message: "当前没有开启自选审批人的功能", duration: 3000 });
    }
    if (currentNode.SignCode == "and_sign") {
      return this.$notify({ type: "warning", message: "会签节点，不支持自选审批人", duration: 3000 });
    }
    this.isShowApprovelPerson = true;
  }

  chooseApprovelConfrim(value: any) {
    (this.activeNode as any)[activePropCode] = value.RoleID;
    // this.activeNode[activePropCode] = value.RoleID;
    this.hideApprovelPerson();
  }

  hideApprovelPerson() {
    this.isShowApprovelPerson = false;
  }

  filterRoleInfo(node: any, index: number) {
    const roles = node?.Roles || [];
    if (node.selectedRoleID) {
      const findRole = roles.find((r: any) => r.RoleID == node.selectedRoleID);
      if (findRole) {
        return findRole.RoleName;
      }
    }

    const role = roles.filter((o: any) => o.DutyCode == DutyCode.Executer).map((item: any) => item.RoleName);
    return role.join(",");
  }
  showServeHint() {
    let __self = this;
    const Products = __self.policys;
    if (Products.length > 1) return __self.model.showHint = true;
    Products.forEach((item: any) => {
      const channelKey = item.Products.some((product: any) => product.SourceID.includes('Qunar'));
      if (__self.model.VoyageType === '1162' && channelKey) return __self.model.showHint = true;
    })
  }
  showSelectCode = false;
  codeColumns = [];
  selectRoleItem: any = {}
  saveBudgetCode(data: { text: string, value: string, BudgetIntro: string, BudgetName: string }) {
    let __self = this;
    if (!data) return __self.showSelectCode = false;
    __self.selectRoleItem.BudgetCode = data.value;
    __self.selectRoleItem.BudgetIntro = data.BudgetIntro;
    __self.selectRoleItem.BudgetName = data.BudgetName;
    __self.showSelectCode = false;
  }
  openSelectBudgetCode(item: RoleInfoEntity) {
    let __self = this;
    __self.selectRoleItem = item;
    const cardNo = __self.findCard(item).CardNo;
    adapterService.searchUserBudgetInfo(cardNo).then((res: any) => {
      if (res.isSucc) {
        let result = res.result || [];
        __self.codeColumns = result.map((item: any) => {
          return {
            text: item.BudgetCode,
            value: item.BudgetCode,
            BudgetIntro: item.BudgetIntro,
            BudgetName: item.BudgetName
          }
        });
        __self.showSelectCode = true;
      } else {
        this.$toast.fail('预算编码查询失败');
      }
    });
  }
  isVisible(code: string) {
    return code.indexOf("invisible") > -1
  }
  // 附件上传
  showLoadFile = false;
  cancelLoad() {
    let __self = this;
    __self.fileList = [];
    __self.showLoadFile = false;
  }
  openLoadFile() {
    let __self = this;
    // 将网络地址用作回显
    __self.fileList = __self.model.ExtraInfos.map(item => {
      return { url: item.ExtraData }
    });
    __self.showLoadFile = true;
  }
  accept = 'image/jpeg, image/jpg, image/png,image/gif, text/plain, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation ,application/pdf'
  /** 上传前置验证 */
  beforeUpload(file: any) {
    const allowedTypes = [
      'image/jpeg',
      "image/jpg",
      'image/png',
      'image/gif',
      'application/pdf',
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "text/plain",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/vnd.ms-powerpoint",
    ]; // 根据需要修改允许的文件类型
    if (Array.isArray(file)) {
      const key = file.some((item: any) => !allowedTypes.includes(item.type))
      if (key) {
        this.$toast.fail("所选文件中存在不支持上传的文件！");
        return false;
      }
    } else {
      if (!allowedTypes.includes(file.type)) {
        this.$toast.fail("暂不支持此文件类型上传！");
        return false;
      }
    }
    return true; // 允许上传
  };

  fileList: any[] = [];
  /** axios上传 */
  uploadFileReturnUrl(data: any) {
    let __self = this;
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: '/api/storage/upload',
        data,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((res: any) => {
          if (res.status!==200) return reject(new Error('上传失败'));
            resolve(res.data);
        })
        .catch((error: string) => {
          reject(error);
        });
    });
  };
  loadFileLoading = false;
  saveFile() {
    let __self = this;
    // 如果存在回显的数据 则没有file 无需再次上传
    const filesToUpload = __self.fileList.filter(item => item.file);
    const loadFiles = filesToUpload.map((item) => {
      const file = item.file;
      let data = new FormData();
      data.append("uploadFile", file);
      return __self.uploadFileReturnUrl(data);
    });
    __self.loadFileLoading = true;
    Promise.all(loadFiles).then((urls: any[]) => {
      __self.$toast.success("保存成功");
      // 如果存在删除项
      const allUrls = __self.fileList.filter(item => item.url).map(item => item.url);
      const fileList = __self.model.ExtraInfos.filter(item => allUrls.includes(item.ExtraData))
      __self.model.ExtraInfos  = [...fileList]
      __self.filepath(urls)
      __self.cancelLoad()
    })
      .catch(() => {
        __self.$toast.fail('上传失败');
      })
      .finally(() => {
        __self.loadFileLoading = false;
      });
  }

  filepath(fileUrls: string[]) {
    let __self = this;
    const files = fileUrls.map(item => {
      return {
        ExtraName: '订单附件',
        ExtraData: item,
        ExtraCode: 'order_attachment',
        ExtraGroup: '',
        FormatCode: 'url',
        IncludeID: '',
        MasterID: '',
        ExtraDataX: '',
        ExtraDataY: '',
        ExtraDataZ: '',
      }
    })
    __self.model.ExtraInfos.push(...files)
  }
  showBtrip = true;
  getBtripExtra(){     
     let __self=this;
     let data = {
      ExtraCode:'company.Btrip',
      MasterID:__self.profile.CompanyID || ''
     };
     SystemService.getCompanyExtra(data).then(p=>{
       if(p.isSucc){
          const btrip=p.result;
          if(btrip && btrip.ExtraCode === 'company.Btrip'){
           if(btrip.ExtraData === 'btrip.show'){
              __self.showBtrip=true;
           }else{
              __self.showBtrip=false;
           }
          }else{
              __self.showBtrip=true;
          }
       }
     })
  }
  resetTranslate(text:string){
    let result = String(text);
    const rules: Array<[RegExp, string]> = [
      [/消费金额上限/g, `${this.$t("mall_order_xiaofeijineshangxian")}`],
      [/当地住宿费标准/g, `${this.$t("mall_order_dangdizhusubiaozhun")}`],
    ];
    if (typeof result !== 'string') {
        return text;
    }
    for (const [pattern, replacement] of rules) {
      result = result.replace(pattern, replacement);
    }
    return result;
  }
  checkExpireDate(role:any) {
    if (!role.ExpireDate || role.CardType != '1139') {
      return false;
    }
    const expireDate = (this as any).$moment(role.ExpireDate);
    const sixMonthsLater = (this as any).$moment().add(6, 'months');
    return expireDate.isBefore(sixMonthsLater);
  }
}
